import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgMydata = function SvgMydata(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsx("rect", {
      width: 32,
      height: 32,
      fill: "white"
    }, void 0), jsx("rect", {
      x: 4,
      y: 6,
      width: 24,
      height: 20,
      rx: 2,
      stroke: "currentColor",
      strokeWidth: 1.5
    }, void 0), jsx("path", {
      d: "M11.2799 15H12.1119V12.088C12.1119 11.56 12.0399 10.8 11.9999 10.264H12.0319L12.4959 11.624L13.5279 14.432H14.1039L15.1279 11.624L15.5999 10.264H15.6319C15.5839 10.8 15.5119 11.56 15.5119 12.088V15H16.3759V9.112H15.3039L14.2399 12.088C14.1039 12.48 13.9919 12.88 13.8559 13.28H13.8159C13.6799 12.88 13.5599 12.48 13.4239 12.088L12.3439 9.112H11.2799V15ZM21.3925 10.6H20.4965L19.7925 12.864L19.4485 14.104H19.4085C19.2725 13.696 19.1365 13.256 19.0085 12.864L18.1925 10.6H17.2485L18.9925 14.968L18.9045 15.272C18.7445 15.744 18.4645 16.096 17.9845 16.096C17.8725 16.096 17.7445 16.056 17.6645 16.032L17.4885 16.752C17.6405 16.808 17.8165 16.84 18.0405 16.84C18.9685 16.84 19.4325 16.208 19.7765 15.264L21.3925 10.6ZM7.95569 23H9.53169C11.2917 23 12.3237 21.944 12.3237 20.032C12.3237 18.112 11.2917 17.112 9.48369 17.112H7.95569V23ZM8.88369 22.24V17.864H9.41969C10.6837 17.864 11.3637 18.56 11.3637 20.032C11.3637 21.496 10.6837 22.24 9.41969 22.24H8.88369ZM14.5094 23.104C15.0374 23.104 15.5094 22.84 15.9094 22.496H15.9334L16.0134 23H16.7654V20.352C16.7654 19.184 16.2614 18.488 15.1654 18.488C14.4614 18.488 13.8454 18.776 13.3894 19.064L13.7334 19.688C14.1094 19.448 14.5414 19.24 15.0054 19.24C15.6534 19.24 15.8374 19.688 15.8454 20.2C14.0134 20.4 13.2134 20.888 13.2134 21.832C13.2134 22.608 13.7494 23.104 14.5094 23.104ZM14.7894 22.376C14.3974 22.376 14.1014 22.2 14.1014 21.768C14.1014 21.272 14.5414 20.944 15.8454 20.784V21.864C15.4854 22.192 15.1734 22.376 14.7894 22.376ZM19.4182 23.104C19.7382 23.104 20.0342 23.024 20.2822 22.944L20.1142 22.264C19.9862 22.32 19.7942 22.368 19.6422 22.368C19.1862 22.368 19.0022 22.096 19.0022 21.568V19.336H20.1462V18.6H19.0022V17.384H18.2262L18.1222 18.6L17.4422 18.648V19.336H18.0822V21.56C18.0822 22.488 18.4262 23.104 19.4182 23.104ZM21.9548 23.104C22.4828 23.104 22.9548 22.84 23.3548 22.496H23.3788L23.4588 23H24.2108V20.352C24.2108 19.184 23.7068 18.488 22.6108 18.488C21.9068 18.488 21.2908 18.776 20.8348 19.064L21.1788 19.688C21.5548 19.448 21.9868 19.24 22.4508 19.24C23.0988 19.24 23.2828 19.688 23.2908 20.2C21.4588 20.4 20.6588 20.888 20.6588 21.832C20.6588 22.608 21.1948 23.104 21.9548 23.104ZM22.2348 22.376C21.8428 22.376 21.5468 22.2 21.5468 21.768C21.5468 21.272 21.9868 20.944 23.2908 20.784V21.864C22.9308 22.192 22.6188 22.376 22.2348 22.376Z",
      fill: "currentColor"
    }, void 0)]
  }), void 0);
};

export { SvgMydata as default };
